import React, { Dispatch, SetStateAction } from 'react'
import { Content } from './Content'
import { LaboratoryTestProvider } from '~/context'
import { IHealthProcedures } from '~/interfaces'

interface LaboratoryTestDetailsProps {
  patientId: number
  healthProcedure: IHealthProcedures
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
}

export const LaboratoryTestDetails = ({
  showModal,
  setShowModal,
  patientId,
  healthProcedure
}: LaboratoryTestDetailsProps): JSX.Element => {
  return (
    <LaboratoryTestProvider>
      <Content
        showModal={showModal}
        setShowModal={setShowModal}
        patientId={patientId}
        healthProcedure={healthProcedure}
      />
    </LaboratoryTestProvider>
  )
}
